import { BrandStory } from './body/brand-story/BrandStory';
import { Customer } from './body/customer/Customer';
import { Download } from './download/Download';
import { Philosophy } from './philosophy/Philosophy';
import { Matching } from './matching/Matching';
import { Epyt } from './epyt/Epyt';
import { Definition } from './body/Definition';
import { Creator } from './body/creator/Creator';
import { Brand } from './body/brand/Brand';
import { Pouch } from './body/pouch/Pouch';
import { Header, headers } from './layout/header/Header';
import { Footer } from './layout/footer/Footer';

export const Main = () => {
    return (
        <div className="w-full flex flex-col items-center justify-center overflow-x-hidden">
            <Header />
            <Epyt />
            <Philosophy />

            <section
                id={headers[2].id}
                className="w-full flex flex-col xl:flex-row xl:gap-0 items-start justify-start pt-[120px] xl:pt-[500px] relative"
            >
                <aside className="w-full xl:w-1/2 xl:sticky xl:top-[100px] xl:self-start">
                    <Definition />
                </aside>

                <article className="w-full xl:w-1/2 flex flex-col items-center justify-start">
                    <BrandStory />
                    <Customer />
                    <Creator />
                    <Brand />
                </article>
            </section>

            <Pouch />
            <Matching />

            <Download />
            <Footer />
        </div>
    );
};
